import Vue from 'vue'
import moment from 'moment'
import Request from './http/request'

import VueShepherd from 'vue-shepherd';

const EXCLUDED_PROD = [
    '52.59.217.237',
    'localhost'
]

if (typeof process.env.VUE_APP_URL !== 'undefined') {
    const API_URL = process.env.VUE_APP_URL
    let p = 'http'

    if (typeof process.env.VUE_APP_API_PROTOCOL !== 'undefined')
        p = process.env.VUE_APP_API_PROTOCOL

    window.request = new Request({baseURL: `${p}://${API_URL}/api/`, loginUrl: '/login'})
}
else {
    const API_URL = !EXCLUDED_PROD.includes(window.location.hostname)
        ? 'api.' + window.location.host
        : 'api.ss-portal.x.devitprosteer.com'
    window.request = new Request({baseURL: `https://${API_URL}/api/`, loginUrl: '/login'})
}

import {library} from '@fortawesome/fontawesome-svg-core'

import {
    faCoffee,
    faFileAlt,
    faUser,
    faMoneyCheckAlt,
    faWeight,
    faClipboard,
    faUserClock,
    faHandshake,
    faTape,
    faDiagnoses,
    faShippingFast,
    faUserCog,
    faEdit,
    faQuestionCircle,
    faPhoneSquare,
    faMapSigns,
    faAngleDown,
    faFilter,
    faSearch,
    faPlus,
    faSpinner,
    faPlusCircle,
    faPalette,
    faChalkboard,
    faTimes,
    faTimesCircle,
    faArrowLeft,
    faCheckSquare,
    faCalendarDay,
    faBars,
    faThLarge,
    faChevronLeft,
    faChevronRight,
    faArrowsAltH,
    faArrowsAltV,
    faCogs,
    faChevronDown,
    faChevronUp,
    faEye,
    faClipboardList,
    faCalendarTimes,
    faCalendarCheck,
    faEnvelope,
    faReplyAll,
    faCommentDots,
    faSlidersH,
    faLongArrowAltRight,
    faUserPlus,
    faShareAlt,
    faStream,
    faDollarSign,
    faTruck,
    faTools,
    faMinus,
    faFile,
    faGripVertical,
    faSearchPlus,
    faSearchMinus,
    faExclamationTriangle,
    faCashRegister,
    faHandHoldingUsd,
    faCheckCircle,
    faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import veeValidate from 'vee-validate'
import App from './App.vue'
import router from './router'
import store from './store/store'
import {_} from 'lodash'
import VueTheMask from 'vue-the-mask'
import PortalVue from 'portal-vue'
import SvgIcon from '@/components/svgIcon'
Vue.component('svg-icon', SvgIcon)
import './index.css'

Vue.use(PortalVue)
Vue.use(VueShepherd)

library.add(
    faInfoCircle,
    faCheckCircle,
    faCashRegister,
    faCoffee,
    faFileAlt,
    faUser,
    faMoneyCheckAlt,
    faWeight,
    faClipboard,
    faUserClock,
    faHandshake,
    faTape,
    faDiagnoses,
    faShippingFast,
    faUserCog,
    faEdit,
    faQuestionCircle,
    faPhoneSquare,
    faMapSigns,
    faAngleDown,
    faFilter,
    faSearch,
    faPlus,
    faSpinner,
    faPlusCircle,
    faPalette,
    faChalkboard,
    faTimes,
    faTimesCircle,
    faArrowLeft,
    faCheckSquare,
    faCalendarDay,
    faBars,
    faThLarge,
    faChevronLeft,
    faChevronRight,
    faArrowsAltH,
    faArrowsAltV,
    faCogs,
    faChevronDown,
    faChevronUp,
    faEye,
    faClipboardList,
    faCalendarTimes,
    faCalendarCheck,
    faEnvelope,
    faReplyAll,
    faCommentDots,
    faSlidersH,
    faLongArrowAltRight,
    faUserPlus,
    faShareAlt,
    faStream,
    faDollarSign,
    faTruck,
    faTools,
    faMinus,
    faFile,
    faGripVertical,
    faSearchPlus,
    faSearchMinus,
    faExclamationTriangle,
    faHandHoldingUsd
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
veeValidate.Validator.extend('uri_safe', {
    getMessage: field => 'The forward slash (\'/\') is not allowed.',
    validate: value => !value.includes('/')
})

Vue.use(veeValidate, {
    events: 'input',
    classes: true,
    classNames: {
        invalid: 'form__input_error',
    }
})

Vue.use(VueTheMask)

// import SuccessReg from './views/Success'
Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD MMM YYYY')
    }
})

Vue.filter('formatMoney', function(value){
  if (value){
    let val = (value/1).toFixed(2).replace(',', '.')
    return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  return '$0.00'
})

new Vue({
    router,
    store,
    render: h => h(App),

}).$mount('#app')
